//ADD_SETTING
export const USER_ADD_SETTING_REQUEST = "USER_ADD_SETTING_REQUEST";
export const USER_ADD_SETTING_SUCCESS = "USER_ADD_SETTING_SUCCESS";
export const USER_ADD_SETTING_FAIL = "USER_ADD_SETTING_FAIL";

//GET_USER_SETTING
export const GET_USER_SETTING_REQUEST = "GET_USER_SETTING_REQUEST";
export const GET_USER_SETTING_SUCCESS = "GET_USER_SETTING_SUCCESS";
export const GET_USER_SETTING_FAIL = "GET_USER_SETTING_FAIL";

//UPDATE_MARK_IN_USER
export const UPDATE_MARK_IN_USER_REQUEST = "UPDATE_MARK_IN_USER_REQUEST";
export const UPDATE_MARK_IN_USER_SUCCESS = "UPDATE_MARK_IN_USER_SUCCESS";
export const UPDATE_MARK_IN_USER_FAIL = "UPDATE_MARK_IN_USER_FAIL";

//ADD_WORKING_FROM_IN_USER
export const ADD_WORKING_FROM_IN_USER_REQUEST =
  "ADD_WORKING_FROM_IN_USER_REQUEST";
export const ADD_WORKING_FROM_IN_USER_SUCCESS =
  "ADD_WORKING_FROM_IN_USER_SUCCESS";
export const ADD_WORKING_FROM_IN_USER_FAIL = "ADD_WORKING_FROM_IN_USER_FAIL";

//GET_COMPANY_PAYROLL_COMP_SETTING
export const GET_COMPANY_PAYROLL_COMP_IN_USERS_SETTING_REQUEST =
  "GET_COMPANY_PAYROLL_COMP_IN_USERS_SETTING_REQUEST";
export const GET_COMPANY_PAYROLL_COMP_IN_USERS_SETTING_SUCCESS =
  "GET_COMPANY_PAYROLL_COMP_IN_USERS_SETTING_SUCCESS";
export const GET_COMPANY_PAYROLL_COMP_IN_USERS_SETTING_FAIL =
  "GET_COMPANY_PAYROLL_COMP_IN_USERS_SETTING_FAIL";

//GET_ALL_COMPANY_SETTING
export const GET_COMPANY_ALL_SETTING_REQUEST =
  "GET_COMPANY_ALL_SETTING_REQUEST";
export const GET_COMPANY_ALL_SETTING_SUCCESS =
  "GET_COMPANY_ALL_SETTING_SUCCESS";
export const GET_COMPANY_ALL_SETTING_FAIL = "GET_COMPANY_ALL_SETTING_FAIL";
